module.exports = __webpack_public_path__ + "static/media/026.fa26d0dd.jpg";